<div class="ui-profile-avatar">
  <div class="ui-profile-avatar__media">
    @if (imageSrc()) {
      <img [src]="imageSrc()" [alt]="alt() | uiLabelTranslate" class="ui-profile-avatar__image" />
    } @else {
      <div class="ui-profile-avatar__fallback" aria-hidden="true">{{ displayInitials() }}</div>
    }

    <div class="ui-profile-avatar__overlay">
      <label class="ui-profile-avatar__action" [attr.aria-label]="editLabel() | uiLabelTranslate">
        <span class="material-symbols-rounded" aria-hidden="true">edit</span>
        <span>{{ editLabel() | uiLabelTranslate }}</span>
        <input class="ui-profile-avatar__input" type="file" accept="image/*" (change)="onFileSelected($event)" />
      </label>

      @if (canDelete()) {
        <button type="button" class="ui-profile-avatar__action ui-profile-avatar__action--danger" (click)="onRemoveClicked()">
          <span class="material-symbols-rounded" aria-hidden="true">remove_circle</span>
          <span>{{ deleteLabel() | uiLabelTranslate }}</span>
        </button>
      }
    </div>
  </div>

  @if (label() || hint()) {
    <div class="ui-profile-avatar__copy">
      @if (label()) {
        <p class="ui-profile-avatar__label">{{ label() | uiLabelTranslate }}</p>
      }
      @if (hint()) {
        <p class="ui-profile-avatar__hint">{{ hint() | uiLabelTranslate }}</p>
      }
    </div>
  }
</div>
